import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import logisticsApi from '../lib/logisticsApi';

const LogisticsExerciseContext = createContext(null);

const STORAGE_KEY = 'ls_selected_exercise_id';

export const LogisticsExerciseProvider = ({ children }) => {
  const [exercises, setExercises] = useState([]);
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem(STORAGE_KEY) || null);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const list = await logisticsApi.listExercises();
      setExercises(list);
      if (list.length > 0) {
        const stored = localStorage.getItem(STORAGE_KEY);
        const match = list.find(e => e.logistics_exercise_id === stored);
        if (match) {
          setSelected(match);
          setSelectedId(match.logistics_exercise_id);
        } else {
          setSelected(list[0]);
          setSelectedId(list[0].logistics_exercise_id);
          localStorage.setItem(STORAGE_KEY, list[0].logistics_exercise_id);
        }
      } else {
        setSelected(null);
        setSelectedId(null);
      }
    } catch {
      setExercises([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const select = useCallback((exId) => {
    const ex = exercises.find(e => e.logistics_exercise_id === exId);
    if (ex) {
      setSelected(ex);
      setSelectedId(exId);
      localStorage.setItem(STORAGE_KEY, exId);
    }
  }, [exercises]);

  const clear = useCallback(() => {
    setSelected(null);
    setSelectedId(null);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return (
    <LogisticsExerciseContext.Provider value={{
      exercises, selected, selectedId, loading, select, clear, refresh,
    }}>
      {children}
    </LogisticsExerciseContext.Provider>
  );
};

export const useLogisticsExercise = () => {
  const ctx = useContext(LogisticsExerciseContext);
  if (!ctx) throw new Error('useLogisticsExercise must be inside LogisticsExerciseProvider');
  return ctx;
};

export default LogisticsExerciseContext;
